"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApplicationError = /** @class */ (function (_super) {
    __extends(ApplicationError, _super);
    function ApplicationError(_a) {
        var message = _a.message, error = _a.error, status = _a.status, _b = _a.isAuthError, isAuthError = _b === void 0 ? false : _b, body = _a.body, fieldErrors = _a.fieldErrors;
        var _this = _super.call(this, message || error.message) || this;
        Error.captureStackTrace(_this, ApplicationError);
        _this.status = status;
        _this.isAuthError = isAuthError;
        _this.body = body;
        _this.fieldErrors = fieldErrors;
        return _this;
    }
    return ApplicationError;
}(Error));
exports.default = ApplicationError;
//# sourceMappingURL=ApplicationError.js.map